import { createModule } from "redux-mvc";

import model from "./model";

import sagasModule from "./sagas";

import HeaderBarModule from "Portal/NewPortal/HeaderBar";
import HomeModule from "Portal/NewPortal/PortalHome";

import SessionFlyOverModule from "Portal/NewPortal/Sections/Sessions/FlyOver";
import TaskFlyOverModule from "Portal/NewPortal/Sections/Home/Cards/Tasks/FlyOver";
import ResourcesFlyOverModule from "Portal/NewPortal/Sections/Resources/FlyOver";
import tabsModule from "ui-kit/Tabs";

const module = createModule({
  ...model
});

module.setRootSaga(sagasModule);
module.plugModule(HeaderBarModule);
module.plugModule(HomeModule);
module.plugModule(SessionFlyOverModule);
module.plugModule(TaskFlyOverModule);
module.plugModule(ResourcesFlyOverModule);
module.plugModule(tabsModule);

export default module;
